import { render, staticRenderFns } from "./AddAndEditStoreSplitRule.vue?vue&type=template&id=4d44f8b6&scoped=true&"
import script from "./AddAndEditStoreSplitRule.vue?vue&type=script&lang=ts&"
export * from "./AddAndEditStoreSplitRule.vue?vue&type=script&lang=ts&"
import style0 from "./AddAndEditStoreSplitRule.vue?vue&type=style&index=0&id=4d44f8b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d44f8b6",
  null
  
)

export default component.exports